import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
    formControl: {
        minWidth: 120,
        width: '100%',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    buttons: {
        '& button': {
            marginRight: theme.spacing(1),
            '&:last-child': {
                marginRight: 0,
            },
        },
    },
    btn: {
        marginTop: theme.spacing(2),
    },
    actionButton: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        position: 'relative',
        transition: 'all .3s ease-in',
    },
    filterRow: {
        marginTop: theme.spacing(1),
    },
    actionButtonsFixed: {
        position: 'fixed',
        top: '50px',
        right: '40px',
        zIndex: 200,
        transition: 'all .3s ease-in',
    },
    orderButton: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(2),
        cursor: 'pointer',
        fontSize: '1.2rem',
    },
    orderCount: {
        fontSize: '1.4rem',
        paddingLeft: theme.spacing(2),
        fontWeight: 'bold',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: '100%',
        display: 'flex',
    },
    tab: {
        padding: 0,
        flex: 1,
        width: '100%',
        textAlign: 'left',
        position: 'relative',
    },
    tabWrapper: {
        alignItems: 'start',
    },
    infinityScroll: {
        minWidth: '230px',
        width: '100%',
    },
    badge: {
        marginLeft: theme.spacing(8),
        background: theme.palette.secondary.light,
    },
}));
